module.exports = __webpack_public_path__ + "static/media/payment.792382c4.png";